module.exports = "/static/assets/aa27b71c7ae6f32740b23e783b11ef85.png";